import React, { useContext, useState } from "react";
import { Alert, AlertTitle, Box, Button, Collapse, Typography, Paper } from "@mui/material";
import CampaignIcon from "@mui/icons-material/Campaign";
import ShareIcon from "@mui/icons-material/Share";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { SiteVarsContext } from "../../contexts/sitevars-context";

export const TransferAnnouncementBanner = () => {
  const { siteVarsData } = useContext(SiteVarsContext);
  const [expanded, setExpanded] = useState(false);

  const announcement = siteVarsData?.game_vars?.latestAnnouncement;
  if (!announcement || !announcement.text) {
    return null;
  }

  const shareText = announcement.text.replace(/\*/g, ""); // strip markdown asterisks for plain text sharing
  const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(shareText)}`;

  return (
    <Box sx={{ p: 1, maxWidth: 650, margin: "0 auto 12px auto" }}>
      <Alert
        icon={<CampaignIcon fontSize="inherit" />}
        severity="info"
        sx={{
          backgroundColor: "#e8f4fd",
          borderRadius: 2,
          boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
        }}
        action={
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Button
              size="small"
              variant="outlined"
              color="primary"
              startIcon={<ShareIcon />}
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              sx={{ textTransform: "none", fontSize: "0.75rem", py: 0.2 }}
            >
              Share
            </Button>
            <Button
              size="small"
              onClick={() => setExpanded(!expanded)}
              endIcon={expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              sx={{ textTransform: "none", fontSize: "0.75rem", py: 0.2 }}
            >
              {expanded ? "Hide" : "View"}
            </Button>
          </Box>
        }
      >
        <AlertTitle sx={{ fontWeight: "bold", mb: 0.5, fontSize: "0.95rem" }}>
          Transfer Window {announcement.window} – Round {announcement.phase} Results
        </AlertTitle>
        <Typography variant="caption" color="text.secondary">
          Posted {new Date(announcement.timestamp).toLocaleDateString("en-GB", { hour: "2-digit", minute: "2-digit" })}
        </Typography>

        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <Paper
            variant="outlined"
            sx={{
              p: 1.5,
              mt: 1.5,
              backgroundColor: "#ffffff",
              whiteSpace: "pre-line",
              fontSize: "0.85rem",
              lineHeight: 1.5,
            }}
          >
            {announcement.text}
          </Paper>
        </Collapse>
      </Alert>
    </Box>
  );
};

